<template>
  <div class="header flex justify-center items-center px-16 pb-8" id="project">
    <div class="container mx-auto w-screen">
      <div class="grid grid-cols-1 gap-8 items-center py-5">
        <div class="left-side place-content-center">
          <h3 class="position text-center font-semibold text-xl lg:text-2xl">
            MY PROJECT
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,600;1,400&family=Poppins:ital,wght@0,300;0,600;1,300&family=Roboto&display=swap");
.position {
  font-family: "Montserrat", sans-serif;
}
</style>
